import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const commissaryTransferRoutes: RouteObject[] = [
  {
    path: '/inmate-account/commissary-transfer',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Texting/Video Purchases',
      crumb: () => ({ label: 'Texting/Video Purchases', to: '/inmate-account/commissary-transfer' }),
    },
  },
];

export default commissaryTransferRoutes;
